export default "__VITE_ASSET__DJpQc1sN__"